







import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "../fixedPhrase/FixedPhraseTreeSelector.vue";
import { IEditFixedPhrase } from "../fixedPhrase/IEditFixedPhrase";
import { FixedPhraseTreeSelectorMixin } from "../fixedPhrase/mixins";
import { FixedPhraseKinds } from "../fixedPhrase/FixedPhraseKinds";
import { AiFixedPhraseSelectorMixin } from "./mixins";
import { AiSyntaxDialog } from "./dialogs";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
    AiSyntaxDialog,
  }
})
export default class AiCommonDepartmentFixedPhraseSelector extends Mixins(
  AiFixedPhraseSelectorMixin,
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop({ default: true })
  isPastable: boolean;

  async created(): Promise<void> {
    try {
      const fixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.AiCommonDepartment);
      this.rootFixedPhrase = fixedPhrase;
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "全" + this.$wording.common.departmentAsShort + "生成AI定型文取得失敗",
        "全" + this.$wording.common.departmentAsShort + "生成AI定型文を読み込めませんでした。",
        e);
      }
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.AiCommonDepartment, isForcibly), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.AiCommonDepartment);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.AiCommonDepartment, "", this.aiFixedPhraseOptions);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.AiCommonDepartment, result);
  }
}
